import { useEffect, useRef } from "react";
import { useRecoilValue } from "recoil";
import { authState } from "../Recoil/RecoilState";
import { StreamURL } from "../utils/StaticVariables";

const useNotificationWebSocket = ({ onMessage }) => {
  const { token } = useRecoilValue(authState);
  const wsRef = useRef(null);

  useEffect(() => {
    if (!token) return;
      const newStreamUrl =
      StreamURL + `notify?token=${token}`;
    const ws = new WebSocket(newStreamUrl);
    wsRef.current = ws;

    const handleClose = (reason) => {
      // console.error("WebSocket closed:", reason);
      ws.close();
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        // console.log('newNotesasdasd',event);
        if (data.status === "error") handleClose(data.message);
        else onMessage(data);
      } catch (err) {
        handleClose("Invalid JSON message");
      }
    };

    ws.onerror = (err) => handleClose("WebSocket error");

    return () => ws.close();
  }, [token, onMessage]);
};

export default useNotificationWebSocket;
